<div class="container-sm">

  <h2>My Tickets</h2>

  <ul id="tickets">
    <li *ngFor="let ticket of tickets">
      <button class="btn btn-outline-danger float-right"
              (click)="cancel(ticket)"
      >Cancel</button>
      <dl>
        <dt>Route</dt>
        <dd>{{ ticket.routeName }}</dd>
      </dl>
<!--      <dl>
        <dt>Date & Time</dt>
        <dd>{{ ticket.time | date:'dd/MM/yyyy HH:mm' }}</dd>
      </dl>-->
    </li>
  </ul>

  <div class="alert alert-info" *ngIf="!tickets.length">
    You didn't book tickets for the next few days.. <a routerLink="/steps/route">Book now</a>.
  </div>

</div>
